<template>
  <!-- Modal -->
  <div
    class="modal"
    id="add-urgent"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Add To Urgent List</h3>
        </div>
        <div class="modal-body bg-white">
          <div class="row">
            <div class="col-md-12 mb-10">
              <div class="icheck-danger">
                <input
                  type="radio"
                  checked
                  name="urgent_reason"
                  value="fast_track"
                  id="urgent-reason1"
                />
                <label for="urgent-reason1">Fast Track</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="urgent_reason"
                  value="repair"
                  id="urgent-reason2"
                />
                <label for="urgent-reason2">Repair</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="urgent_reason"
                  value="remake"
                  id="urgent-reason3"
                />
                <label for="urgent-reason3">Remake</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="urgent_reason"
                  value="return"
                  id="urgent-reason4"
                />
                <label for="urgent-reason4">Return</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="urgent_reason"
                  value="prod_time"
                  id="urgent-reason5"
                />
                <label for="urgent-reason5">Prod Time</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="urgent_reason"
                  value="support_special"
                  id="urgent-reason6"
                />
                <label for="urgent-reason6">Support: Special</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            CANCEL
          </button>
          <button type="button" class="btn btn-primary" @click="addToUrgent()">
            CONFIRM
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    addToUrgent() {
      let urgent_reason = $("input[name='urgent_reason']:checked").val();
      this.$emit("submit", urgent_reason);
    },
  },
};
</script>
